import { useHistory } from 'react-router';
import { Image, Stack } from '@chakra-ui/react';
import { Typography } from '@shinetools/sunshine-universal';

import {
  ShineRecurringAccountingExportSettings,
  ShineRecurringAccountingExportSettingsType,
} from '__generated__/GQL';
import articlesImage from 'assets/brand/articles.png';
import Button from 'components/_core/Button';
import SunshineCard from 'components/_core/SunshineCard';
import Text from 'components/_core/Text';

import * as routes from '../../../../routes';
import { ContainedOptionRow } from './components/ContainedOptionRow';
import locales from './locales';

type SharedKeys = Pick<
  ShineRecurringAccountingExportSettings,
  'type' | 'settings'
>;

type CreatedExportSetting = Pick<
  ShineRecurringAccountingExportSettings,
  keyof SharedKeys | 'cadence' | 'cadenceOffset'
>;

export const Confirmation = (createdExportSetting: CreatedExportSetting) => {
  const history = useHistory();

  const { description, title } = locales[createdExportSetting.type];

  const formattedDescriptino =
    createdExportSetting.type ===
    ShineRecurringAccountingExportSettingsType.ShineRecurring
      ? locales.formatString(description, {
          date: createdExportSetting.cadenceOffset + 1,
          period: locales.cadence[createdExportSetting.cadence],
        })
      : /**
         * @todo Show confirmation for one-off exports
         * @see https://linear.app/shine/issue/CAC-1052
         */
        '';

  return (
    <SunshineCard.Group>
      <SunshineCard>
        <SunshineCard.Content gap="space-16">
          <Image
            alignSelf="center"
            marginBottom="space-8"
            src={articlesImage}
            width="180px"
          />

          <Typography.Header size="large">{title}</Typography.Header>

          {/**
           * We need to make some words bold, hence old component
           */}
          <Text variant="primary">{formattedDescriptino}</Text>

          <Typography.Text>{locales.contains}</Typography.Text>

          <Stack gap="space-10">
            {createdExportSetting.settings.formats.map((format) => (
              <ContainedOptionRow
                key={format}
                label={locales.formatString(locales.exportFormat, {
                  format: locales[format],
                })}
              />
            ))}

            {createdExportSetting.settings.includeInvoices ? (
              <ContainedOptionRow label={locales.invoices} />
            ) : null}

            {createdExportSetting.settings.includePersonalTransactions ? (
              <ContainedOptionRow label={locales.personalTransactions} />
            ) : null}

            {createdExportSetting.settings.includeBankStatements ? (
              <ContainedOptionRow label={locales.bankStatements} />
            ) : null}
          </Stack>
        </SunshineCard.Content>
      </SunshineCard>

      <SunshineCard>
        <SunshineCard.Content alignItems="center" padding="space-8">
          <Button isExpanded onClick={() => history.push(routes.exports)}>
            {locales.confirm}
          </Button>
        </SunshineCard.Content>
      </SunshineCard>
    </SunshineCard.Group>
  );
};
